"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const eventemitter3_1 = require("eventemitter3");
const logger_1 = require("./logger");
class EncodingQueue extends eventemitter3_1.EventEmitter {
    constructor() {
        super();
        this.fileReader = new FileReader();
        this._queue = [];
        this._processing = false;
        this.fileReader.onload = (evt) => {
            this._processing = false;
            if (evt.target) {
                this.emit('done', evt.target.result);
            }
            this.doNextTask();
        };
        this.fileReader.onerror = (evt) => {
            logger_1.default.error(`EncodingQueue error:`, evt);
            this._processing = false;
            this.destroy();
            this.emit('error', evt);
        };
    }
    get queue() {
        return this._queue;
    }
    get size() {
        return this.queue.length;
    }
    get processing() {
        return this._processing;
    }
    enque(blob) {
        this.queue.push(blob);
        if (this.processing)
            return;
        this.doNextTask();
    }
    destroy() {
        this.fileReader.abort();
        this._queue = [];
    }
    doNextTask() {
        if (this.size === 0)
            return;
        if (this.processing)
            return;
        this._processing = true;
        this.fileReader.readAsArrayBuffer(this.queue.shift());
    }
}
exports.EncodingQueue = EncodingQueue;
